class InView {
	constructor() {
		this.observers = {};

		const elements = document.querySelectorAll('[data-in-view]');
		elements.forEach((element) => {
			const offset = element.getAttribute('data-offset');
			const observer = this.getObserverByOffset(offset);
			observer.observe(element);
		});
	}

	getObserverByOffset(offset) {
		if (null === offset || 0 === offset || '0' === offset) {
			offset = '0';
		}

		if ('undefined' === typeof this.observers[offset]) {
			this.observers[offset] = new IntersectionObserver(this.callback, {
				rootMargin: `${offset}px`,
			});
		}

		return this.observers[offset];
	}

	callback(entries) {
		entries.forEach((entry) => {
			if (!entry.target) {
				return false;
			}

			if (entry.isIntersecting) {
				const eventIn = new CustomEvent('in-view:in');
				entry.target.setAttribute('data-in-view', 'true');
				entry.target.dispatchEvent(eventIn);
			} else {
				const eventOut = new CustomEvent('in-view:out');
				entry.target.setAttribute('data-in-view', 'false');
				entry.target.dispatchEvent(eventOut);
			}
		});
	}
}

new InView();
